export default __webpack_public_path__ + "2de4711518848208657ff6c71cd1f5b2.png";